import { useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';
import { mapToDomain, Message } from '@infuse/e-connector/message/domain';
import { getMessage } from '@infuse/api/e-connector/message';

export const useMessage = () => {
  const fetchMessageId = ref<string | undefined>(undefined);

  const query = useQuery<Message>({
    queryKey: ['messages', 'detail', fetchMessageId],
    enabled: () => !!fetchMessageId.value,
    queryFn: async () => {
      const response = await getMessage({ id: fetchMessageId.value });
      return mapToDomain(response);
    }
  });

  return {
    ...query,
    fetchMessageId,
    message: query.data
  };
};
